import { useMutation } from '@tanstack/react-query';

import { useDebounce } from '../../../../../hooks';
import * as service from '../services';
import { useOmnichannelStore } from '../store/ModuloOmnichannel.store';
import { OmnichannelSavedFiltersList } from '../types';

export const useOmnichannelGetSavedFilters = () => {
  const debounce = useDebounce();

  const setOmnichannelState = useOmnichannelStore(state => state.setOmnichannelState);

  const mutate = useMutation({
    mutationFn: (query: string) => service.getOmnichannelSavedFilters(query),
    onSuccess: data => {
      if (data?.data) {
        setOmnichannelState('omnichannelSavedFiltersList', data.data);
        setOmnichannelState(
          'omnichannelSavedFiltersSelectList',
          data.data.map((item: OmnichannelSavedFiltersList) => ({
            value: item.idFiltroSalvo,
            label: item.nomeFiltroSalvo,
          })),
        );
      }
    },
  });

  const handleGetSavedFiltersSearch = (query: string) => {
    debounce(() => mutate.mutate(query));
  };

  return {
    handleGetSavedFilters: mutate.mutate,
    handleGetSavedFiltersSearch,
    data: mutate.data?.data,
    isLoading: mutate.isPending,
    isError: mutate.isError,
  };
};
